<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false" width="100%" top="vh" :append-to-body="true" custom-class="preview-dialog">
    <div class="preview-wrapper">
      <div class="preview-operations">
        <i class="el-icon-zoom-in" @click="handleZoomIn" title="放大" />
        <i class="el-icon-zoom-out" :class="{ disabled: scale <= 1 }" @click="handleZoomOut" title="缩小" />
        <i class="el-icon-refresh-right" @click="handleRotateRight" title="右旋转" />
        <i class="el-icon-refresh-left" @click="handleRotateLeft" title="左旋转" />
        <i class="el-icon-close" @click="handleClose" title="关闭" />
      </div>
      <div class="preview-body" ref="bodyRef">
        <img
          ref="imgRef"
          :src="src"
          :style="{ transform: `scale3d(${scale}, ${scale}, 1) rotate(${rotate}deg)`, left: position.x + 'px', top: position.y + 'px' }"
          @mousedown="handleMouseDown"
        />
      </div>
      <div v-if="list.length > 1" class="preview-nav">
        <i class="el-icon-arrow-left" :class="{ disabled: i === 0 }" @click="handleLeft" />
        <i class="el-icon-arrow-right" :class="{ disabled: i === list.length - 1 }" @click="handleRight" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Preview',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      scale: 1,
      rotate: 0,
      position: { x: 0, y: 0 },
      origin: { x: 0, y: 0, deltaX: 0, deltaY: 0 },
      isMoving: false,
      i: 0,
      src: ''
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.i = this.index
        this.src = this.list[this.i]
        this.resetState()
      }
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleMouseUp)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
  },
  methods: {
    resetState() {
      this.scale = 1
      this.rotate = 0
      this.position = { x: 0, y: 0 }
    },
    handleZoomIn() {
      this.scale++
    },
    handleZoomOut() {
      if (this.scale > 1) this.scale--
    },
    handleRotateRight() {
      this.rotate += 90
    },
    handleRotateLeft() {
      this.rotate -= 90
    },
    handleLeft() {
      if (this.i > 0) {
        this.i--
        this.src = this.list[this.i]
        this.resetState()
      }
    },
    handleRight() {
      if (this.i < this.list.length - 1) {
        this.i++
        this.src = this.list[this.i]
        this.resetState()
      }
    },
    handleMouseDown(e) {
      e.preventDefault()
      this.origin.deltaX = e.pageX - this.position.x
      this.origin.deltaY = e.pageY - this.position.y
      this.isMoving = true
    },
    handleMouseMove(e) {
      if (this.visible && this.isMoving) {
        this.position.x = e.pageX - this.origin.deltaX
        this.position.y = e.pageY - this.origin.deltaY
      }
    },
    handleMouseUp() {
      this.isMoving = false
    },
    handleClose() {
      this.dialogVisible = false
      setTimeout(() => this.resetState(), 300)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  background-color: transparent;
}
.preview-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.1);
  user-select: none;

  .preview-operations {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    display: flex;
    flex-direction: row-reverse;
    padding: 12px;
    background: rgba(0, 0, 0, 0.3);
    width: 100%;

    i {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.85);
      cursor: pointer;
      margin-left: 16px;

      &:hover {
        color: #fff;
      }

      &.disabled {
        color: rgba(255, 255, 255, 0.3);
        cursor: not-allowed;
      }
    }
  }

  .preview-body {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 90%;
      max-height: 90%;
      position: relative;
      cursor: grab;
      transition: transform 0.3s;
      user-select: none;

      &:active {
        cursor: grabbing;
      }
    }
  }

  .preview-nav {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    pointer-events: none;

    i {
      font-size: 24px;
      color: rgba(255, 255, 255, 0.85);
      cursor: pointer;
      pointer-events: auto;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: rgba(0, 0, 0, 0.5);
      }

      &.disabled {
        color: rgba(255, 255, 255, 0.3);
        cursor: not-allowed;
      }
    }
  }
}
</style>

<style lang="scss">
.preview-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
